import React from 'react'

import './CSS/Home.css'
import Sliders from '../Components/Sliders/Sliders'
import Categories from '../Components/Categories/Categories'
const Home = () => {

  return (
    <div>
       <Sliders/>
       <Categories/>
    </div>
  )
}

export default Home
